var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3533 19.5275C7.3533 20.065 6.92663 20.495 6.49997 20.495C6.0733 20.495 5.64663 20.065 5.64663 19.5275C5.64663 18.99 6.0733 18.56 6.49997 18.56C7.0333 18.56 7.3533 18.99 7.3533 19.5275ZM8.52663 2.005H4.4733C4.36663 2.005 4.25997 2.1125 4.25997 2.22V2.3275C4.25997 2.435 4.36663 2.5425 4.4733 2.5425H8.52663C8.6333 2.5425 8.73997 2.435 8.73997 2.3275V2.22C8.73997 2.1125 8.6333 2.005 8.52663 2.005ZM12.3666 20.065V2.435C12.3666 0.5 10.5533 0.5 10.5533 0.5H2.44663C2.44663 0.5 0.633301 0.5 0.633301 2.435V19.9575C0.633301 21.8925 2.44663 21.8925 2.44663 21.8925H10.5533C10.5533 21.8714 12.2137 22 12.3666 20.065ZM1.5933 2.435C1.5933 2.005 1.69997 1.79 2.01997 1.575C2.2333 1.4675 2.44663 1.4675 2.5533 1.4675H10.5533C10.66 1.4675 10.8733 1.4675 11.0866 1.575C11.4066 1.6825 11.5133 1.8975 11.5133 2.435V2.9725H1.5933V2.435ZM1.5933 3.94H11.4066V17.1625H1.5933V3.94ZM1.5933 20.065V18.13H11.4066V20.065C11.4066 20.495 11.3 20.71 10.98 20.925C10.7666 21.0325 10.5533 21.0325 10.4466 21.0325H2.33997C2.2333 21.0325 2.01997 21.0325 1.80663 20.925C1.69997 20.71 1.5933 20.495 1.5933 20.065Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMobile);
export default __webpack_public_path__ + "static/media/phone-mobile.96bd37b79457c077fad645a43bc1f510.svg";
export { ForwardRef as ReactComponent };